export default "__VITE_ASSET__f1fb8dfb__"